import { render } from "./InquiryDetail.m.vue?vue&type=template&id=46eb9366&scoped=true"
import script from "./InquiryDetail.m.vue?vue&type=script&lang=js"
export * from "./InquiryDetail.m.vue?vue&type=script&lang=js"

import "./InquiryDetail.m.vue?vue&type=style&index=0&id=46eb9366&scoped=true&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46eb9366"]])

export default __exports__